<template>
    <div class="kits-list">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Nombre</th>
                    <th>Referencia</th>
                    <th>Items</th>
                    <th>Mano de Obra Técnica</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="kit in kits" :key="kit.id">
                    <td>{{ kit.name }}</td>
                    <td>{{ kit.reference }}</td>
                    <td>
                        <ul class="list-unstyled mb-0">
                            <li v-for="item in kit.items" :key="item.id">
                                {{ item.pivot.quantity }}x {{ item.name }} ({{ item.reference }})
                            </li>
                        </ul>
                    </td>
                    <td>{{ formatCurrency(kit.technical_labor) }}</td>
                    <td>
                        <button class="btn btn-sm btn-primary" v-if="userCan('update-kits')" @click="onEdit(kit)">
                            <i class="fa fa-edit"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" v-if="userCan('delete-kits')" @click="onDelete(kit)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
                <tr v-if="kits.length === 0">
                    <td colspan="5" class="text-center text-muted">
                        No hay kits registrados
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import { mixin } from '../../../../mixin';

export default {
    mixins: [mixin],
    props: {
        kits: {
            type: Array,
            default: () => []
        },
        onEdit: {
            type: Function,
            required: true
        },
        onDelete: {
            type: Function,
            required: true
        }
    },
    methods: {
        formatCurrency(value) {
            if (!value) return '$0';
            return new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: 'COP',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(value);
        }
    }
};
</script>

